// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { QuestionnaireDesignApi } from '../types/questionnaire-design.types';
import { questionnaireDesignHttpApi } from './questionnaire-design.api';
import { questionnaireDesignMockApi } from './questionnaire-design.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const questionnaireDesignApi: QuestionnaireDesignApi = useMock
  ? questionnaireDesignMockApi
  : questionnaireDesignHttpApi;
